import React, { useState, useEffect } from 'react'

import { FormElementWrapper, Button, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { oneOf, func, string } from 'prop-types'

import WithTriangleUiContext from 'Pods/Shared/Hocs/WithTriangleUiContext'
import i18n from 'Pods/Shared/I18n'

import useBreakpoint from 'Utils/useBreakpoint'

import buttons from './Static/buttons'

function RemainingCardSizeSetting({ saveCardSizeSetting, cardSizeSetting: initialCardSizeSetting, locale = 'en' }) {
  const [cardSize, setCardSize] = useState()
  const windowSize = useBreakpoint()
  const shouldDisplayTitleDivider = ['xs', 'sm', 'md', 'lg'].includes(windowSize)

  const cardSizeLabel = i18n.t('listingPage.filters.cardSize', { ns: 'rails', lng: locale })

  useEffect(() => {
    setCardSize(initialCardSizeSetting)
  }, [initialCardSizeSetting])

  function handleClick(key) {
    setCardSize(key)
    saveCardSizeSetting(key)
  }

  function renderButtons() {
    return buttons.map(({ key, value }) => (
      <Button
        key={key}
        trailIcon={<Icon svgComponent={value} color="light" />}
        size="medium"
        type="secondary"
        variant="only-icon"
        customClass="remaining-filters__card-size-button"
        isActive={cardSize === key}
        onClick={() => handleClick(key)}
      />
    ))
  }

  return (
    <div className="remaining-filters__card-size">
      <FormElementWrapper title={cardSizeLabel} withTitleDivider={shouldDisplayTitleDivider}>
        <div className="remaining-filters__card-size-wrapper">{renderButtons()}</div>
      </FormElementWrapper>
    </div>
  )
}

RemainingCardSizeSetting.propTypes = {
  saveCardSizeSetting: func.isRequired,
  cardSizeSetting: oneOf(['small', 'medium', 'large']).isRequired,
  locale: string,
}

const mapStateToProps = ({ saveCardSizeSetting, cardSizeSetting, locale }) => {
  return {
    saveCardSizeSetting,
    cardSizeSetting,
    locale,
  }
}

export default WithTriangleUiContext(mapStateToProps)(RemainingCardSizeSetting)
